// ONE place that decides how a product looks and how it becomes a cart line.
// Every page (home, shop, product page, cart, checkout, wishlist) goes through these helpers,
// so a name, price, image or tag can never be formatted differently in two places.
import { getProductImage, getSizePrice, isSizeSoldOut } from "../components/v2/constants";

/** ₹1,499 - Indian digit grouping everywhere. */
export const formatPrice = (n) => `₹${Number(n || 0).toLocaleString("en-IN")}`;

/** The one image shown for a product (cards, cart, checkout, wishlist). */
export const productImage = (product) => getProductImage(product || {});

/** Cart line for one product + size. Name, image, price and tags always come from the product. */
export const buildCartLine = (product, size, quantity = 1, isGiftBox = false) => ({
  product_id: product.id,
  product_name: product.name,
  size,
  quantity,
  unit_price: getSizePrice(product, size),
  image: productImage(product),
  is_gift_box: isGiftBox,
  fragrance_family: product.fragrance_family || "",
  tags: product.tags || [],
});

/** Refresh the display fields of a stored cart line from the live product (price, name, image, tags). */
export const refreshCartLine = (line, product) => {
  if (!product) return line;
  const price = getSizePrice(product, line.size);
  return {
    ...line,
    product_name: product.name,
    image: productImage(product),
    fragrance_family: product.fragrance_family || "",
    tags: product.tags || [],
    unit_price: line.is_gift_box ? line.unit_price : (price || line.unit_price),
    // true when this size can no longer be bought; the cart and checkout block until it's removed
    unavailable: isSizeSoldOut(product, line.size),
  };
};
